import type { OwnStayIngredient } from '@apps/main/modules/recipe/ingredients/ownStayIngredient';

import { DESTINATION_PRODUCTS_PREFIX } from '../constants';
import { ActivitySerializer } from '../../activitiySerializer';
import {
  serializeNumberOfNights,
  serializeTransportType,
} from '../serializeStay';

import { OWN_STAY_INGREDIENT_SUFFIX, PROPS_PREFIX } from './constants';

export function serializeOwnStay(ownStay: OwnStayIngredient): string {
  let result = serializeConstraintText(ownStay);

  result += serializeDestinationProducts(ownStay);

  result += PROPS_PREFIX;

  result += serializeNumberOfNights(ownStay);

  result += serializeTransportType(ownStay);

  result += OWN_STAY_INGREDIENT_SUFFIX;

  return result;
}

export function serializeConstraintText(ownStay: OwnStayIngredient): string {
  return ownStay.getSearchText();
}

export function serializeDestinationProducts(
  ownStay: OwnStayIngredient
): string {
  if (ownStay.subIngredients.length > 0) {
    const serializedActivities = ownStay.subIngredients.map(
      (activityIngredient) =>
        `${DESTINATION_PRODUCTS_PREFIX}${ActivitySerializer.serialize(
          activityIngredient
        )}`
    );
    return serializedActivities.join('');
  }

  return '';
}
